/**
 * C6 — what a KPI can watch for one client: every integration metric plus
 * the client's custom metrics (its own and "All"). Views are tables, not one
 * number, so they are left out, as in AgencyAnalytics.
 */

import { useEffect, useMemo, useState } from 'react';

import { customApi, VIEW_PREFIX, type CustomMetric } from '../custom/custom-api.ts';
import { withCustom } from '../custom/with-custom.ts';
import type { Catalogue } from '../reports/reports-api.ts';

export function useKpiCatalogue(
  organisationId: string,
  clientId: string,
  catalogue: Catalogue,
): Catalogue {
  const [metrics, setMetrics] = useState<CustomMetric[]>([]);
  useEffect(() => {
    if (!clientId) return;
    customApi
      .metrics(organisationId, clientId)
      .then(setMetrics)
      .catch(() => setMetrics([]));
  }, [organisationId, clientId]);
  return useMemo(() => {
    const merged = withCustom(catalogue, metrics);
    return {
      ...merged,
      sources: merged.sources.filter((source) => !source.key.startsWith(VIEW_PREFIX)),
    };
  }, [catalogue, metrics]);
}
